import { Injectable } from '@angular/core';

export interface Evn {
  production: boolean;
  apiUrl: string;
  storageUrl: string;
  socketUrl: string;
}

const environment: Evn = {
  production: false,
  apiUrl: 'https://elexa.iot.ndrsolution.com/web-api/api/v1',
  // apiUrl: 'http://10.10.10.157:9999/api/v1',
  storageUrl: 'http://159.138.252.132:8080/axis2/services/FIAPStorage',
  socketUrl: 'http://localhost:3000'
}

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor() { }

  getApiUrl(partUrl?:string) {
    let url = (partUrl || environment.apiUrl);
    let api = environment.apiUrl+url
    return api;
  }

  getStorageUrl(partUrl?:string) {
    let url = (partUrl || environment.storageUrl);
    let api = environment.storageUrl
    return api;
  }

}
